export const temperatureConverter = [
  { value: "celsius", label: "°C" },
  { value: "fahrenheit", label: "°F" },
  { value: "kelvin", label: "°K" },
];

export const pressureConverter = [
  { value: "mbar", label: "mB" },
  { value: "pascal", label: "pascal" },
  { value: "kPa", label: "Kilopascal" },
  { value: "MPa", label: "Megapascal" },
  { value: "hPa", label: "Hectopascal" },
  { value: "Torr", label: "Torr" },
  { value: "psi", label: "psi" },
];

export const shipTypeData = [
  {
    value: "1",
    label: "Passenger Ship",
  },
  {
    value: "2",
    label: "Oil Tanker",
  },
  {
    value: "3",
    label: "Chemical Tanker",
  },
  {
    value: "4",
    label: "Bulk Carrier",
  },
  {
    value: "5",
    label: "Container",
  },
  {
    value: "6",
    label: "Other Cargo Ship",
  },
  {
    value: "7",
    label: "Ro-ro",
  },
  {
    value: "8",
    label: "Other (specify)",
  },
];

export const vesselTypeData = [
  {
    value: "VT1",
    label: "Passenger Ship",
  },
  {
    value: "VT2",
    label: "Oil Tanker",
  },
  {
    value: "VT3",
    label: "Chemical Tanker",
  },
  {
    value: "VT4",
    label: "Bulk Carrier",
  },
  {
    value: "VT5",
    label: "Container",
  },
  {
    value: "VT6",
    label: "Other Cargo Ship",
  },
  {
    value: "VT7",
    label: "Ro-ro",
  },
  {
    value: "VT8",
    label: "Other",
  },
];

export const secData = [
  {
    value: "SEC1",
    label: "Security Level 1",
  },
  {
    value: "SEC2",
    label: "Security Level 2",
  },
  {
    value: "SEC3",
    label: "Security Level 3",
  },
];

export const cidrillsData = [
  {
    value: "1",
    label:
      "Emergency steering drill at least once every 3 months - SOLAS V/26.4",
  },
  {
    value: "2",
    label:
      "Check and test of steering gear within 12 hours before departure - SOLAS V/26.1 and 26.2",
  },
  {
    value: "3",
    label: "Other (inc Weekly for ships regularly engaged in short voyages)",
  },
];

export const gmdssOptsData = [
  {
    value: "0",
    label: "Please Select Item...",
  },
  {
    value: "1",
    label: "N/A",
  },
  {
    value: "2",
    label: "Daily",
  },
  {
    value: "3",
    label: "Weekly",
  },
  {
    value: "4",
    label: "Monthly",
  },
];

export const povData = [
  {
    value: "POV1",
    label: "IMO",
  },
  {
    value: "POV2",
    label: "Official No",
  },
  {
    value: "POV3",
    label: "PLN",
  },
];

export const boolnaData = [
  {
    value: "0",
    label: "Please select option",
  },
  {
    value: "1",
    label: "Yes",
  },
  {
    value: "2",
    label: "No",
  },
  {
    value: "3",
    label: "NA",
  },
];

export const secstatusData = [
  {
    value: "1",
    label: "Security state 1",
  },
  {
    value: "2",
    label: "Security state 2",
  },
  {
    value: "3",
    label: "Security state 3",
  },
];

export const oilrec1Data = [
  {
    value: "ORS",
    label: "Oily Residues (Sludge)",
  },
  {
    value: "SS",
    label: "Scale and Sludge From Tank Cleaning",
  },
  {
    value: "BTW",
    label: "Bilge Water Tank",
  },
  {
    value: "OTW",
    label: "Oily Tanks Washings",
  },
  {
    value: "DBW",
    label: "Dirty Ballast Water",
  },
  {
    value: "DOT",
    label: "Dirty Oil Tank",
  },
  { value: "OT", label: "Other" },
];

export const oilrec2Data = [
  {
    value: "ORS",
    label: "Oily Residues (Sludge)",
  },
  {
    value: "SST",
    label: "Scale & Sludge From Tank Cleaning",
  },
  {
    value: "BTW",
    label: "Bilge Water Tank",
  },
  {
    value: "DOT",
    label: "Dirty Oil Tank",
  },
  { value: "OT", label: "Other" },
];

export const ozonetypeData = [
  {
    value: "REF",
    label: "Refrigerant",
  },
  {
    value: "RFD",
    label: "Refrigerant Discharge",
  },
  {
    value: "LKT",
    label: "Leak Test",
  },
];
